<template>
    <gmap-marker v-if="position" :icon="image" :position="position" v-on:click="onClick()"></gmap-marker>
</template>

<script>

export default {
  name: 'fox-position',
  props: ['fox', 'onClick'],
  computed: {
    image () {
      return 'static/' + this.fox + '.png';
    },
    position() {
        var pos = this.$store.getters[this.fox][0];
        if(pos == undefined)
            return false;

        return {lat: parseFloat(pos.lat), lng: parseFloat(pos.lng)};
    }
  },
  methods: {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/maps/FoxPosition.vue